import { CashSettlement } from "../../types";
import { SettlementFieldState } from "./types";

export const SETTLEMENT_LABEL = "Trades are paid from";

export const SETTLEMENT_SEGMENTS: Array<{
  value: CashSettlement;
  label: string;
}> = [
  { value: "OWN_CASH", label: "This account's cash" },
  { value: "LINKED_ACCOUNT", label: "Another account" },
];

export const SETTLEMENT_HELPER =
  "Another account settles buys and sells from its balance, so this one holds no cash of its own.";

export const SETTLEMENT_LOCKED_NOTE = "Fixed once the ledger has activity.";

export const SETTLEMENT_ACCOUNT_LABEL = "Paying account *";

const SETTLEMENT_ACCOUNT_REQUIRED = "Pick the account that pays the trades!";

export const settlementAccountRule = (isRequired: boolean) => ({
  validate: (account: unknown) =>
    !isRequired || account !== null || SETTLEMENT_ACCOUNT_REQUIRED,
});

export const settlementSummaryOf = ({
  value,
  account,
}: Pick<SettlementFieldState, "value" | "account">) =>
  value === "LINKED_ACCOUNT"
    ? `Paid from ${account?.label ?? "another account"}`
    : "This account's cash";
